
export { default as T } from "./T.js"
export { default as complement } from "./complement.js"
export { default as compose } from "./compose.js"
export { default as cond } from "./cond.js"
export { default as curry } from "./curry.js"
export { default as equals } from "./equals.js"
export { default as gt } from "./gt.js"
export { default as gte } from "./gte.js"
export { default as isNil } from "./isNil.js"
export { default as lt } from "./lt.js"
export { default as when } from "./when.js"